import * as stylex from '@stylexjs/stylex';
import './tokens.stylex';
import { borderRadius, focus, negativeSpacing } from './tokens.stylex';
export const resets = {
  button: {
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    kaIpWk: "xakuvmb",
    kMzoRj: "xc342km",
    kybGjl: "x1hl2dhg",
    kfiyM8: "xc26acl",
    kysU6D: "xjyslct",
    kWkggS: "xjbqb8w",
    kMwMTN: "x15rks2t",
    kkrTdU: "x1ypdohk",
    k1xSpc: "x1rg5ohu",
    kLWn49: "x14ju556",
    kjBf7l: "x1uczgqu x1xw63cm",
    kInvED: "x1k1u8hp",
    k3XXqK: "xaatb59",
    kMeerF: "x64kyde",
    $$css: true
  },
  list: {
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    kB88ic: "xe8uvvx",
    $$css: true
  },
  listItem: {
    k1xSpc: "x1lliihq",
    $$css: true
  }
};